// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__b8u3C","title":"FrontImage_title__1pkuV"};